import { Box, Tooltip } from '@mui/material';
import React from 'react';
import GroupAvatar from 'v2/components/GroupAvatarCell/GroupAvatar';
import RepeatOverflowCounter from 'v2/components/RepeatOverflowCounter/RepeatOverflowCounter';

interface Group {
  id: string;
  name: string;
}

interface Props {
  groups: Group[];
  emptyState?: React.ReactNode;
}

const GroupAvatarCell: React.FC<Props> = ({ groups, emptyState }) => {
  if (groups.length === 0 && emptyState) return <>{emptyState}</>;

  return (
    <Box display="flex" justifyContent="flex-start" alignItems="center" height="100%">
      <RepeatOverflowCounter
        variant="avatar"
        size="small"
        renderMore={(count) => {
          const tooltipTitle = groups
            .slice(-count)
            .map((g) => g.name ?? '')
            .join(', ');
          return (
            <Tooltip title={tooltipTitle} placement="top">
              <GroupAvatar label={`+${count}`} />
            </Tooltip>
          );
        }}
      >
        {groups.map((group) => (
          <Tooltip title={group.name} placement="top" key={group.id}>
            <GroupAvatar label={(group.name ?? '').slice(0, 2).toUpperCase()} />
          </Tooltip>
        ))}
      </RepeatOverflowCounter>
    </Box>
  );
};

export default GroupAvatarCell;
